<template>
  <div class="triage-container">
    <wizard-triage-basic
      v-if="item.triage === 'basic'"
      :triage="triageBasic"
      @wizardTriageCompleted="loadResult"
    />
    <wizard-triage-full
      v-else
      :triage="triageFull"
      :show-not-customer="item.triage !== 'full-without-notcustomer'"
      @wizardTriageCompleted="loadResult"
    />
    <template v-if="showResult">
      <div v-if="!result" class="result-container">loading...</div>
      <div v-else class="result-container" v-html="result"></div>
    </template>
  </div>
</template>

<script>
import { client } from '@/helpers/http'

import WizardTriageBasic from './WizardTriageBasic'
import WizardTriageFull from './WizardTriageFull'

export default {
  name: 'WizardTriage',
  components: {
    WizardTriageFull,
    WizardTriageBasic,
  },
  props: {
    triageBasic: {
      type: Object,
      default: () => ({}),
    },
    triageFull: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    result: '',
    showResult: false,
  }),
  methods: {
    async loadResult(contentPath) {
      this.showResult = true
      this.$emit('wizardTriageCompleted', contentPath)
      const result = await client().get(contentPath + '.html')
      this.result = result.data
    },
  },
}
</script>

<style scoped>
.triage-container {
  margin-bottom: 10px;

  p {
    margin: 20px 0;
  }

  .result-container {
    border-top: 1px solid var(--c-secondary-neutral-2);
    border-bottom: 1px solid var(--c-secondary-neutral-2);
    padding: 20px 0;
  }
}
</style>
